import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { IHandelssoritmentgruppInformation } from "../arbetsorder-produktval/arbetsorder-produktval.models";
import { ArbetsorderProduktvalService } from "../arbetsorder-produktval/arbetsorder-produktval.service";
import { IProduktionsmall } from "../produktionsmallar/produktionsmall-produktval.models";
import { ProduktvalTableComponent } from "./produktval-table/produktval-table.component";
import { IHandelssortimentsgrupp, IProduktvalRow, ProduktvalEvent } from "./produktval.models";

@Component({
    selector: "rask-produktval",
    styleUrls: ["./produktval.component.scss"],
    templateUrl: "./produktval.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ProduktvalTableComponent]
})
export class ProduktvalComponent implements OnInit, OnChanges, OnDestroy {
    @Input() canEdit: boolean;
    @Input() onBeforeSelectionEvent: ($event: ProduktvalEvent) => Promise<boolean>;
    gruppInformation: IHandelssoritmentgruppInformation[] = [];
    @Input() handelssortimentsgruppProduktvalsrader: { [key: string]: IProduktvalRow[] };
    @Input() handelssortimentsgrupper: IHandelssortimentsgrupp[];
    handelssortimentsgrupperHandelssortiment: any = {};
    @Input() isProduktvalApplicable: boolean;
    @Input() isSimuleringApplicable: boolean;
    @Input() layout: "div" | "table" = "div";
    @Input() mall: IProduktionsmall;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @angular-eslint/no-output-rename
    @Output("onSelectionEvent") selectionEvent = new EventEmitter<ProduktvalEvent>();
    @Input() visaEndastMedProduktionsmal: boolean;

    private readonly arbetsorderProduktvalService = inject(ArbetsorderProduktvalService);
    private readonly destroy$ = new Subject<void>();

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.handelssortimentsgrupper && changes.handelssortimentsgrupper.currentValue !== changes.handelssortimentsgrupper.previousValue) {
            this.initialize();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.initialize();
        this.arbetsorderProduktvalService.volymAttFordela$.pipe(
            takeUntil(this.destroy$)
        ).subscribe(() => {
            this.loadGruppInfo();
        });
    }

    onSelectionEvent($event: ProduktvalEvent): void {
        this.selectionEvent.emit($event);
    }

    private initialize(): void {
        if (this.handelssortimentsgrupper === null || this.handelssortimentsgrupper === undefined) {
            this.handelssortimentsgrupper = [];
        }

        if (this.handelssortimentsgruppProduktvalsrader === null || this.handelssortimentsgruppProduktvalsrader === undefined) {
            this.handelssortimentsgruppProduktvalsrader = {};
        }

        this.loadGruppInfo();
    }

    private loadGruppInfo(): void {
        this.gruppInformation = [] as IHandelssoritmentgruppInformation[];

        this.handelssortimentsgrupper.forEach(x => {
            const gruppVolym = this.arbetsorderProduktvalService.volymAttFordela$.value?.filter(p => p.handelssortimentsgruppId === x.gruppId)[0]?.volym;
            if (this.isProduktvalApplicable) {
                this.handelssortimentsgrupperHandelssortiment[x.grupp] = x.handelssortiment;
                this.gruppInformation.push({
                    handelssortimentsgruppNamn: x.grupp,
                    handelssortimentsgruppVolym: gruppVolym
                });
            } else {
                if (this.handelssortimentsgruppProduktvalsrader[x.grupp]) {
                    this.handelssortimentsgrupperHandelssortiment[x.grupp] = x.handelssortiment;
                    this.gruppInformation.push({
                        handelssortimentsgruppNamn: x.grupp,
                        handelssortimentsgruppVolym: gruppVolym
                    });
                }
            }
        });
    }
}
